import { supabase } from "@/integrations/supabase/client";

export async function logEvent(event: string, action: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;
  const { data: profile } = await supabase
    .from("profiles")
    .select("full_name")
    .eq("id", user.id)
    .single();
  await (supabase as any).from("events_log").insert({
    user_id: user.id,
    user_name: profile?.full_name || user.email || "",
    event,
    action,
  });
}
